import React from "react"
import { Button, StyleProps } from "@chakra-ui/react"
import { getBrightness, parseColor } from "utilities/colors"

// Darken a color by a percentage
const darken = (color: string, amount: number = 10): string => {
  const rgb = parseColor(color)
  if (!rgb) {
    return color
  }

  const r = Math.max(0, Math.floor(rgb.r * (1 - amount / 100)))
  const g = Math.max(0, Math.floor(rgb.g * (1 - amount / 100)))
  const b = Math.max(0, Math.floor(rgb.b * (1 - amount / 100)))

  return `#${[r, g, b].map((x) => {
    const hex = x.toString(16)

    return hex.length === 1 ? `0${hex}` : hex
  }).join("")}`
}

const DEFAULT_ACTION_BUTTON_COLOR = "#4990E2"

const ActionButton = ({
  text,
  color,
  buttonClick,
  minW = 48,
}: {
  text: string
  color?: string
  buttonClick: () => void
  minW?: StyleProps["minW"]
}) => {
  const bgColor = color ?? DEFAULT_ACTION_BUTTON_COLOR
  const brightness = getBrightness(bgColor)

  return (
    <Button
      onClick={buttonClick}
      color={brightness > 170 ? "black" : "white"}
      backgroundColor={bgColor}
      _hover={{ backgroundColor: darken(bgColor) }}
      minW={minW}
    >
      {text}
    </Button>
  )
}

export default ActionButton
